/// <reference types="./show.d.mts" />
import * as $app_common_cl from "../../../../app_config/app_config/content_library.mjs";
import * as $bright from "../../../../bright/bright.mjs";
import * as $connector from "../../../../common/data/connector.mjs";
import * as $data_source from "../../../../common/data/data_source.mjs";
import * as $language from "../../../../common/data/translate/language.mjs";
import * as $iso639 from "../../../../common/data/translate/language/iso639.mjs";
import * as $user from "../../../../common/data/user.mjs";
import * as $timestamp_ from "../../../../common_common/gleam/time/timestamp/extra.mjs";
import * as $checkbox from "../../../../ds/ds/components/checkbox.mjs";
import * as $label from "../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../../ds/ds/components/profile_picture.mjs";
import * as $table from "../../../../ds/ds/components/table.mjs";
import * as $tooltip from "../../../../ds/ds/components/tooltip.mjs";
import * as $events from "../../../../ds/ds/events.mjs";
import * as $icons from "../../../../ds/ds/icons.mjs";
import * as $ds_utils from "../../../../ds/ds/utils.mjs";
import * as $bool from "../../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../../gleam_stdlib/gleam/function.mjs";
import * as $list from "../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $order from "../../../../gleam_stdlib/gleam/order.mjs";
import * as $pair from "../../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../../gleam_time/gleam/time/timestamp.mjs";
import * as $a from "../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $content_library from "../../../data/content_library.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import * as $cl_common from "../../../frontend/view/content_library/common.mjs";
import * as $cl_s from "../../../frontend/view/styles/content_library.mjs";
import * as $ps from "../../../frontend/view/styles/proposals.mjs";
import { Ok, toList, isEqual } from "../../../gleam.mjs";

function sources_upload_action() {
  return $h.label(
    toList([]),
    toList([
      $ps.main_file_input(
        toList([]),
        toList([$icons.small($icons.add()), $h.text("Select files")]),
      ),
      $h.input(
        toList([
          $a.type_("file"),
          $a.attribute("multiple", "true"),
          $a.style("display", "none"),
          $events.on_files_change(
            (files) => {
              return $decode.success(new $msg.UserUploadedSourceFiles(files));
            },
          ),
        ]),
      ),
    ]),
  );
}

function view_sources_table_headers() {
  return $table.headers(
    toList([
      (() => {
        let _pipe = $table.header("");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Format");
        return $table.fit(_pipe);
      })(),
      $table.header("Name"),
      (() => {
        let _pipe = $table.header("Language");
        return $table.fit(_pipe);
      })(),
      (() => {
        let _pipe = $table.header("Status");
        return $table.fit(_pipe);
      })(),
      $table.header("Owner"),
      (() => {
        let _pipe = $table.header("Due Date");
        return $table.fit(_pipe);
      })(),
      $table.header("Tags"),
      $table.header("Creator"),
      (() => {
        let _pipe = $table.header("");
        return $table.fit(_pipe);
      })(),
    ]),
  );
}

function view_sources_data(model, sources) {
  let state = $bright.state(model);
  let user_id = $state.current_user_id(state);
  let is_admin = $state.is_admin(state);
  let is_super_admin = $state.is_super_admin(state);
  return $table.body(
    $list.map(
      sources,
      (source) => {
        let owner = $state.find_user(state, source.owner);
        let is_processing = isEqual(
          source.status,
          new $data_source.Processing()
        );
        let has_failed = isEqual(source.status, new $data_source.Failed());
        let user_allowed_to_modify = (isEqual(source.owner, user_id)) || is_admin;
        let disabled = (!user_allowed_to_modify || is_processing) || has_failed;
        let _pipe = $table.row(
          toList([
            (() => {
              let _pipe = $table.cell(
                $checkbox.checkbox(
                  $checkbox.checked(
                    $content_library.is_selected(
                      state.content_library,
                      source.id,
                    ),
                  ),
                  disabled,
                  (checked) => {
                    return new $msg.ContentLibrary(
                      new $msg.UserSelectedSource(source.id, checked),
                    );
                  },
                ),
              );
              return $table.stop_cell_propagation(_pipe);
            })(),
            $table.cell(
              $cl_s.source_icon(
                disabled,
                toList([]),
                toList([
                  $icons.small(
                    $ds_utils.select_icon(source.display.mime_type, source.kind),
                  ),
                ]),
              ),
            ),
            $table.cell(
              $cl_s.source_name(
                disabled,
                toList([]),
                toList([$el.text(source.display.name)]),
              ),
            ),
            (() => {
              let _pipe = $table.cell(
                $h.div(
                  toList([]),
                  toList([
                    $h.text(
                      (() => {
                        let $ = source.display.language;
                        if ($ instanceof $option.Some) {
                          let $1 = $[0];
                          if ($1 === "") {
                            return "";
                          } else {
                            let language = $1;
                            let _pipe = $iso639.parse(language);
                            let _pipe$1 = $result.map(
                              _pipe,
                              $language.to_string,
                            );
                            let _pipe$2 = $result.map(
                              _pipe$1,
                              $string.capitalise,
                            );
                            return $result.unwrap(_pipe$2, "");
                          }
                        } else {
                          return "";
                        }
                      })(),
                    ),
                  ]),
                ),
              );
              return $table.justify(_pipe, "start");
            })(),
            $table.cell($app_common_cl.view_source_verification_label(source)),
            $table.cell(
              $common.name_small(
                toList([]),
                (() => {
                  if (owner instanceof Ok) {
                    let name = owner[0].name;
                    let picture = owner[0].picture;
                    let initials = owner[0].initials;
                    return toList([
                      $pp.from_user(picture, initials, new $pp.Medium()),
                      $el.text(name),
                    ]);
                  } else {
                    return toList([$el.text("")]);
                  }
                })(),
              ),
            ),
            $table.cell(
              (() => {
                let _block;
                let $1 = source.expiration_date;
                if ($1 instanceof $option.Some) {
                  let expiration_date = $1[0];
                  let _block$1;
                  let $2 = $timestamp.compare(
                    expiration_date,
                    $timestamp.system_time(),
                  );
                  if ($2 instanceof $order.Lt) {
                    _block$1 = $label.error();
                  } else if ($2 instanceof $order.Eq) {
                    _block$1 = $label.success();
                  } else {
                    _block$1 = $label.success();
                  }
                  let _pipe = _block$1;
                  _block = $pair.new$(
                    _pipe,
                    $timestamp_.to_locale_full_date(expiration_date),
                  );
                } else {
                  _block = [$label.neutral(), "None"];
                }
                let $ = _block;
                let status = $[0];
                let content = $[1];
                return $label.label(toList([status, $label.content(content)]));
              })(),
            ),
            $table.cell(
              $l.row(
                toList([$l.gap(8)]),
                toList([]),
                $list.filter_map(
                  source.tags,
                  (tag) => {
                    let tag$1 = $list.find(
                      state.organization.tags,
                      (t) => { return t.id === tag; },
                    );
                    return $result.map(
                      tag$1,
                      (tag) => {
                        return $label.label(
                          toList([$label.neutral(), $label.content(tag.name)]),
                        );
                      },
                    );
                  },
                ),
              ),
            ),
            $table.cell(
              $l.row(
                toList([$l.gap(8)]),
                toList([]),
                $list.filter_map(
                  source.authors,
                  (author) => {
                    let _pipe = state.organization.users;
                    let _pipe$1 = $list.find(
                      _pipe,
                      (u) => {
                        return (u.email === author) || (u.id === author);
                      },
                    );
                    return $result.map(
                      _pipe$1,
                      (u) => {
                        let name = u.name;
                        let picture = u.picture;
                        let initials = u.initials;
                        return $common.name_small(
                          toList([]),
                          toList([
                            $pp.from_user(picture, initials, new $pp.Medium()),
                            $el.text(name),
                          ]),
                        );
                      },
                    );
                  },
                ),
              ),
            ),
            (() => {
              let _pipe = $table.cell(
                (() => {
                  let is_cc_and_done_processing = user_allowed_to_modify && !is_processing;
                  let is_actionable = is_cc_and_done_processing || is_super_admin;
                  return $bool.lazy_guard(
                    !is_actionable,
                    $ps.empty_trash_icon_button,
                    () => {
                      let $ = $connector.is_syncronised_integration(source.kind);
                      if ($) {
                        return $tooltip.tooltip(
                          toList([]),
                          $icons.tiny($icons.info()),
                          $cl_s.integration_deletion_tooltip(
                            toList([]),
                            toList([
                              $h.text(
                                "This file is syncronised with an integration, if you want to delete it go to the integrations page.",
                              ),
                            ]),
                          ),
                        );
                      } else {
                        let _pipe = new $msg.UserDisplayedDeleteDataSourceModal(
                          source.id,
                        );
                        let _pipe$1 = new $msg.ContentLibrary(_pipe);
                        let _pipe$2 = $e.on_click(_pipe$1);
                        let _pipe$3 = $list.wrap(_pipe$2);
                        return $ps.trash_icon_button(
                          _pipe$3,
                          toList([$icons.tiny($icons.trash())]),
                        );
                      }
                    },
                  );
                })(),
              );
              let _pipe$1 = $table.justify(_pipe, "end");
              let _block;
              if (disabled) {
                _block = $function.identity;
              } else {
                _block = $table.stop_cell_propagation;
              }
              return _block(_pipe$1);
            })(),
          ]),
        );
        let _block;
        if (disabled) {
          _block = $function.identity;
        } else {
          _block = (_capture) => {
            return $table.on_click(
              _capture,
              new $msg.UserClickedToOpenLink(
                (() => {
                  let _pipe$1 = source.display.origin;
                  return $option.map(
                    _pipe$1,
                    (_capture) => {
                      return $pair.new$(source.display.name, _capture);
                    },
                  );
                })(),
              ),
            );
          };
        }
        let _pipe$1 = _block(_pipe);
        return $table.row_id(_pipe$1, source.id);
      },
    ),
  );
}

const empty_text = "Connect your Drive, or upload directly files, directly with the button above.";

function view_sources_table_content(model, sources) {
  let data = $bright.state(model);
  let is_loading = data.loading.content_library;
  let is_no_content = $content_library.is_no_content(
    data.content_library.non_qna_sources,
  );
  return $bool.lazy_guard(
    is_loading,
    () => { return $app_common_cl.view_loading_table(8); },
    () => {
      return $bool.lazy_guard(
        is_no_content,
        () => { return $table.empty_table(empty_text, 10); },
        () => { return view_sources_data(model, sources); },
      );
    },
  );
}

export function view(model, page, sources) {
  let state = $bright.state(model);
  let _block;
  let _pipe = state.content_library.stats.sources;
  _block = $option.unwrap(_pipe, new $data_source.StatusStats(0, 0, 0, 0));
  let stats = _block;
  let page$1 = state.content_library.non_qna_sources;
  return $l.fragment(
    toList([
      $l.row(
        toList([$l.gap(32)]),
        toList([]),
        toList([
          $cl_common.state_card(
            "green",
            stats.verified,
            new $data_source.Verified(),
            isEqual(
              new $option.Some(new $data_source.Verified()),
              state.content_library.filter_selected
            ),
          ),
          $cl_common.state_card(
            "blue",
            stats.pending,
            new $data_source.Pending(),
            isEqual(
              new $option.Some(new $data_source.Pending()),
              state.content_library.filter_selected
            ),
          ),
          $cl_common.state_card(
            "grey",
            stats.not_verified,
            new $data_source.NotVerified(),
            isEqual(
              new $option.Some(new $data_source.NotVerified()),
              state.content_library.filter_selected
            ),
          ),
          $cl_common.state_card(
            "red",
            stats.outdated,
            new $data_source.Outdated(),
            isEqual(
              new $option.Some(new $data_source.Outdated()),
              state.content_library.filter_selected
            ),
          ),
        ]),
      ),
      (() => {
        let _pipe$1 = $cl_common.view_content_library_filters(
          model,
          sources_upload_action(),
        );
        return $el.map(
          _pipe$1,
          (var0) => { return new $msg.ContentLibrary(var0); },
        );
      })(),
      $table.table(
        toList([]),
        toList([
          view_sources_table_headers(),
          view_sources_table_content(model, sources),
          $cl_common.footer(state, page$1),
        ]),
      ),
    ]),
  );
}
